import { render, staticRenderFns } from "./airwallex-card.vue?vue&type=template&id=f4d0d928&scoped=true"
import script from "./airwallex-card.vue?vue&type=script&lang=js"
export * from "./airwallex-card.vue?vue&type=script&lang=js"
import style0 from "./airwallex-card.vue?vue&type=style&index=0&id=f4d0d928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0d928",
  null
  
)

export default component.exports